import type { FinishWorkoutStats } from "src/interfaces/FinishWorkoutStats";
import { writable } from "svelte/store";

export const stats = writable<FinishWorkoutStats[]>([]);
